module.exports = __webpack_public_path__ + "static/media/banner_02.6765a510.png";